import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { useInitials } from "@/hooks/use-initials"
import type { CurrentUser } from "@/types"

/**
 * UserInfo — avatar + name (and optional email) used in dropdown menus + sidebar.
 *
 * Sources from the OKS-5 `currentUser` shape (snake_case `avatar_url`).
 */
export function UserInfo({
  user,
  showEmail = false,
}: {
  user: CurrentUser
  showEmail?: boolean
}) {
  const getInitials = useInitials()

  return (
    <>
      <Avatar className="h-8 w-8 overflow-hidden rounded-full">
        <AvatarImage src={user.avatar_url ?? undefined} alt={user.name} />
        <AvatarFallback className="rounded-lg bg-neutral-200 text-black dark:bg-neutral-700 dark:text-white">
          {getInitials(user.name)}
        </AvatarFallback>
      </Avatar>
      <div className="grid flex-1 text-left text-sm leading-tight">
        <span className="truncate font-medium">{user.name}</span>
        {showEmail && (
          <span className="text-muted-foreground truncate text-xs">
            {user.email}
          </span>
        )}
      </div>
    </>
  )
}
